import {NgModule} from '@angular/core';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {PrlLanguageModule} from './view/prl-language/prl-language.module';
import {NgxPaginationModule} from 'ngx-pagination';
import {provideHighcharts} from "highcharts-angular";
import {MatIconRegistry} from '@angular/material/icon';


export function loader(lang: string = 'en'): Observable<any> {
    return of({});
}

@NgModule({
    imports: [
        TranslateModule.forRoot({
            useDefaultLang: true,
            loader: {
                provide: TranslateLoader,
                useValue: {
                    getTranslation: loader
                }
            }
        }),
        BrowserModule,
        CoreModule,
        PrlLanguageModule,
        NgxPaginationModule
    ],
    providers: [
        provideHighcharts(),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer
    ) {
        iconRegistry.addSvgIcon(
            'ms_teams',
            sanitizer.bypassSecurityTrustResourceUrl('assets/ms_teams.svg')
        );
        iconRegistry.addSvgIcon(
            'person',
            sanitizer.bypassSecurityTrustResourceUrl('assets/person.svg')
        );
        iconRegistry.addSvgIcon(
            'phone',
            sanitizer.bypassSecurityTrustResourceUrl('assets/phone.svg')
        );
        iconRegistry.addSvgIcon(
            'write_email',
            sanitizer.bypassSecurityTrustResourceUrl('assets/email.svg')
        );
    }
}
